import { useContext, useEffect } from "react"
import "./style.css"
import { useTranslation } from 'react-i18next'
import PharmDropDown from 'src/component/PharmDropDown'
import { Context } from "src/context"
import { useNavigate } from "react-router-dom"
import { GetRoleId } from "src/utils"
import { ROLES } from "src/common/constants"
import { Menu } from "src/component/SideBar/menu"

const Landing = () => {

    const { t } = useTranslation()

    const { isLoggedIn, authorizedPages } = useContext(Context)

    const navigate = useNavigate()

    useEffect(() => {


        if (isLoggedIn && !!authorizedPages?.length) {
            const isAdAdmin = [ROLES.SUPER_ADMIN, ROLES.PHARMASIST].includes(Number(GetRoleId()))
            const AuhtScreens = authorizedPages?.map(item => item.id) || []
            const ValidUserList = Menu?.filter((screen: any) => screen.id.some((sIds: number) => AuhtScreens.includes(sIds)))

            !isAdAdmin && navigate(ValidUserList[0].path)
        }
    }, [isLoggedIn, authorizedPages])

    return (
        <div className='full-height'>
            <div className="pharmacy-section">
                <h3 className="text-lg font-semibold">{t("Select Pharmacy")}</h3>
                <PharmDropDown />
            </div>
        </div>
    )
}

export default Landing
